<template>
  <div class="unpaid">
    <progressBar
      class="unpaid-progress"
      :arr="progressData"
      :activeIndex="progressActiveIndex"></progressBar>
    <div class="unpaid-top">
      <div class="unpaid-top__name">未支付的物流订单</div>
      <div class="unpaid-top__fun">
        <div class="unpaid-top-item unpaid-top-item--date">
          <div class="unpaid-top-item__name">创建日期:</div>
          <el-date-picker
            size="mini"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </div>
        <div class="unpaid-top-item unpaid-top-item--input">
          <el-input size="mini" placeholder="请输入物流单号"></el-input>
        </div>
        <div class="unpaid-top-item unpaid-top-item--input">
          <el-input size="mini" placeholder="请输入起运地,目的地等"></el-input>
        </div>
        <div class="unpaid-top__btn">搜索</div>
        <div class="unpaid-top__btn">马上支付</div>
      </div>
    </div>
    <div class="unpaid-table">
      <Table height="550" width="1654" :head="tableHead"></Table>
    </div>
  </div>
</template>

<script>
import { LogisticsNewMoodule } from './class'
import progressBar from 'components/common/progressBar';
import Table from 'components/common/Table.vue'
export default {
  name: 'unpaidLogisticsOrders',
  components: {
    progressBar, Table
  },
  data(){
    return {
      /**进度条数据 */
      progressData: LogisticsNewMoodule.NEWORDERPROGRESSARRAY(),
      progressActiveIndex: 4,
      tableHead: LogisticsNewMoodule.NEWUNPAIDTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.unpaid{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    &__fun{
      display: flex;
    }
    &-item{
      display: flex;
      align-items: center;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 100px;
        }
      }
      &__name{
        font-size: 14px;
        margin-right: 5px;
      }
      &--date{
        ::v-deep{
          .el-input__inner{
            width: 180px;
          }
        }
      }
      &--input{
        ::v-deep{
          .el-input__inner{
            width: 180px;
          }
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
